import React from 'react'

function CombineShipHead(props) {
    return (
        <thead
            className="BatchShipHead"
            style={{ background: '#e9ecef' }}
        >
            <tr>
                <th className="Id">ID</th>
                <th className="Create_at">Ngày tạo</th>
                <th className="Update_at">Ngày cập nhật</th>
                <th className="Status">Trạng thái</th>
                <th className="Record">Line ship</th>
                <th className="total-order">Số lượng đơn</th>
                <th className="total-order-success">Số đơn sản xuất xong</th>
                <th className="order-info">Thông tin đơn</th>
                <th className="Action">Action</th>
            </tr>
        </thead>
    )
}

export default CombineShipHead